import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { BlogPostTable } from "@/app/Blogs/Components/BlogPostTable";

export function BlogPostListScreen() {
  return (
    <FullPageScreen>
      <BlogPostTable />
    </FullPageScreen>
  );
}
